module.exports = __webpack_public_path__ + "static/img/btn-setting.8111c57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/tideng/springFestival/cook/btn-setting.png
// module id = S5Jc
// module chunks = 4